import React from 'react'
import SwiperSlider from '../SwiperSlider'
import { Text } from '../Text'

const Advantages = () => {
  return (
    <div>
      <section id='about'>
        <div className=' maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto  p-20 mobile:p-5 tablet:p-5'>
          <div className='flex flex-row items-center text-[#215998]/55 mobile:text-[10px] '>
            <p>03 / 06</p>
            <p className='ml-8 text-[#215998] gap-2'>|</p>
            <p className='ml-8 uppercase text-[36px] font-bold mobile:text-[16px] text-[#215998] tablet:text-[28px]'>
              Давуу талууд
            </p>
          </div>
          <div className='flex flex-row items-center justify-center mobile:flex-col tablet:flex-col h-[80vh] mobile:p-5 '>
            <div className='w-2/4 p-20 mobile:w-[320px] mobile:p-0 tablet:w-full tablet:p-0'>
              <Text
                className=' maxScreen:w-[600px] extraScreen:w-[600px] mr-5 text-[30px] italic text-[#215998] mobile:p-4  tablet:text-[16px] 
              mobile:mr-0 mobile:mb-0 mobile:mt-20 mobile:border mobile:bg-white/55 mobile:rounded-2xl mobile:text-center  mobile:text-[18px]'
                style={{ fontWeight: 500 }}
              >
                Таны шинжлэх ухаанч шийдвэр таны гэр бүлд ирээдүйн эмчилгээний
                боломжийг нээж, эрүүл мэндийн баталгаа, үнэ цэнийг бий болгоно.
              </Text>
            </div>
            <div className='w-2/4 maxScreen:w-3/4 extraScreen:w-[1000px] mobile:w-full mobile:p-0 tablet:w-[610px] '>
              <SwiperSlider />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Advantages
